import React from 'react';
import { componentService } from 'js/services/component.service';

export const BankIDAuth = React.lazy(() => import(/* webpackChunkName: "bank-id-auth" */ './BankIDAuth').then((module) => ({ default: module.BankIDAuth })));
export const BankIDLogin = React.lazy(() => import(/* webpackChunkName: "bank-id-auth" */ './BankIDAuth').then((module) => ({ default: module.BankIDLogin })));
export const BankIDRegistration = React.lazy(() => import(/* webpackChunkName: "bank-id-auth" */ './BankIDAuth').then((module) => ({ default: module.BankIDRegistration })));

// <hub2-bank-id-login></hub2-bank-id-login>
componentService.registerWebContentComponents({ BankIDLogin });
// <hub2-bank-id-registration navigate="/page-name"></hub2-bank-id-registration>
componentService.registerWebContentComponents({ BankIDRegistration });
